import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/component/app-layout/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import {Login} from "@/pages/auth/login/login";
import {authGuard} from "@/pages/auth/auth-guard";

export const appRoutes: Routes = [
    {
        path: 'login',
        component: Login
    },
    {
        path: 'notfound',
        component: Notfound
    },
    {   path: '',
        component: AppLayout,
        children: [
            { path: '', redirectTo: 'settings', pathMatch: 'full' },
            { path: '', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
        ],
        canMatch:[authGuard],
    },
    { path: '**', redirectTo: '/notfound' },
];
